module.exports = require("ramda/src/curryN");